import { doGet, doPost } from '../DataManager';
import { getGlobalState } from '@/store';

/**
 * Gestore da usare per le query hub.
 *
 * Il backend ricava `id_gestore` da `req.query/body.id_gestore` e solo in
 * fallback da `req.updater.gestore`, che per un utente admin MBILITY non
 * esiste: senza il parametro esplicito search e bulk-import rispondono
 * "Missing or invalid id_gestore". Stessa fonte usata da fetchHubs.
 */
const ownManagerId = () => {
  const user = getGlobalState()?.user;
  return user?.gestore || user?.id_gestore || undefined;
};

/**
 * Ricerca hub per prefisso su nome / codice / comune, scoped al gestore.
 *
 * @param {{ q: string, type?: string, limit?: number, id_gestore?: string }} params
 * @returns {Promise<Array<Object>>}
 */
export const searchHubs = async ({ q, type, limit = 20, id_gestore }) =>
  doGet('/v2/fleet/hubs/search', {
    q,
    type,
    limit,
    id_gestore: id_gestore || ownManagerId(),
  });

/**
 * Import massivo di hub con upsert sulla chiave di business (default `code`).
 *
 * @param {{ hubs: Array<Object>, type?: string, upsert_key?: string, id_gestore?: string }} payload
 * @returns {Promise<{created: number, updated: number, skipped: number, errors: Array}>}
 */
export const bulkImportHubs = async (payload) =>
  doPost('/v2/fleet/hubs/bulk-import', {
    ...payload,
    id_gestore: payload?.id_gestore || ownManagerId(),
  });
